'use client';
var classes = {"root":"m-e9408a47","root--default":"m-84c9523a","root--filled":"m-ef274e49","root--unstyled":"m-eda993d3","legend":"m-90794832","legend--unstyled":"m-74ca27fe"};

export { classes as default };
//# sourceMappingURL=Fieldset.module.css.mjs.map
